import React, { useEffect } from 'react';
import { LoadingSpin } from 'common/components/LoadingSpin';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { getStatisticSalesOpsModel } from 'app/store/reducers/statistic.reducer';
import { OrderCard } from 'entities/Statistic/components/Card/OrderCard';
import { StatsCard } from 'entities/Statistic/components/Card/StatsCard';

interface IComponentProps {
  franchiseeId?: string;
  storeId?: string;
  dateFrom?: string;
  dateTo?: string;
}

export const SalesOpsStatistics: React.FC<IComponentProps> = (props) => {
  const dispach = useAppDispatch();
  const { statisticSalesOpsModel } = useAppSelector((state) => state.statistic);
  const { storeId, franchiseeId, dateFrom, dateTo } = props;
  const globalData = statisticSalesOpsModel;
  const statisticData = globalData;

  useEffect(() => {
    dispach(getStatisticSalesOpsModel({ storeId, franchiseeId, dateFrom, dateTo }));
  }, [storeId, franchiseeId, dateFrom, dateTo]);

  return statisticData ? (
    <>
      <StatsCard item={statisticData} />
      <OrderCard item={statisticData} />
    </>
  ) : (
    <LoadingSpin />
  );
};
